module.exports = __webpack_public_path__ + "static/media/video-off.df2d1172.svg";